module.exports = __webpack_public_path__ + "media/images/courses/homework-d96d5a8bbeca8a57eea54422cf9dc9ea.png";